import { pushNotification } from '@frontend/pole-ui/lib/components/Notification'
import classNames from 'classnames'
import { openModal } from '@/components/composed/Modal/actions'
import type { IMessageModalOptions, IModalMessageProps } from '@/components/composed/modals/MessageModal/interfaces'
import type { TOrderRequiredFields } from '@/services/OrderService/interfaces'
import type { INotUploadedDocument } from './interface'
import { messages } from './messages'

const getMessages = (documents: INotUploadedDocument[][]) => {
  return documents.reduce((acc, documentList, index) => {
    const formattedDocuments = documentList.map(({ name }) => ({
      text: name,
      className: 'space-holder8',
    }))

    if (documents.length > 1 && index > 0) {
      return [
        ...acc,
        {
          id: 'messageModal.loadingClosingDocumentModal.or',
          className: 'space-holder16 space-holder-top16 list-with-marks__item_withoutMark',
        },
        ...formattedDocuments,
      ]
    }

    return [...acc, ...formattedDocuments]
  }, [] as IModalMessageProps[])
}

export const openNotUploadedDocumentsModal = (documents: INotUploadedDocument[][]) => {
  return openModal({
    options: {
      dialogId: 'MessageModal',
      headerId: 'messageModal.loadingClosingDocumentModal.title',
    },
    contentOptions: {
      messages: getMessages(documents),
      className: 'list-with-marks',
    } as IMessageModalOptions,
  })
}

export const openRequiredFieldsModal = (requiredFields: TOrderRequiredFields, headerId?: string) => {
  let messagesProps: IModalMessageProps[] = []
  const isArray = Array.isArray(requiredFields)

  if (isArray) {
    messagesProps = requiredFields?.map(({ name }) => ({ text: name }))
  } else if (requiredFields.oneGroup && requiredFields.twoGroup) {
    messagesProps = [
      {
        id: 'messageModal.loadingClosingDocumentModal.and',
        values: { first: requiredFields.oneGroup[0], second: requiredFields.oneGroup[1] },
      },
      {
        id: 'messageModal.loadingClosingDocumentModal.or',
        className: 'error-upload-documents__nomarks space-holder-top8',
      },
      { id: requiredFields.twoGroup[0], className: 'space-holder-top8' },
    ]
  }

  return openModal({
    options: {
      dialogId: 'MessageModal',
      headerId: headerId || 'messageModal.requiredFieldsErrorModal.title',
    },
    contentOptions: {
      messagesProps,
      className: classNames('list-with-marks', { 'error-upload-documents': !isArray }),
    } as IMessageModalOptions,
  })
}

export const showNotificationNotUploadedDocuments = (documents: INotUploadedDocument[][]) => {
  const notificationMessage = getMessages(documents)
    .map(item => item.text || (item.id === 'messageModal.loadingClosingDocumentModal.or' ? 'или' : ''))
    .join('\n')

  return pushNotification(
    {
      status: 'warning',
      title: messages.notification.title,
      description: notificationMessage,
    },
    { duration: 4000 },
  )
}
